import React, { useEffect, useRef, useState } from "react";
import ReactQuill from "react-quill";
import { DatePicker } from "antd";
import { Tabs } from "antd";
import "react-quill/dist/quill.snow.css";
import "react-image-crop/dist/ReactCrop.css";
import "./DaylightClassForm.scss";
import Buttons from "../../../Components/Buttons/Buttons";
import FormInputs from "../../../Components/FormInputs/FormInputs";
import { Checkbox, Select, Switch } from "antd";
import { Modal, Divider, Button, Row, Col, Typography } from "antd";
import { TimePicker } from "antd";
import { Card, Radio } from "antd";
import Cropper from "react-cropper";
import "cropperjs/dist/cropper.css";
import {
  PlusOutlined,
  DeleteOutlined,
} from "@ant-design/icons";
import dayjs from "dayjs";
import {
  ADD_NEW_DAYLIGHT_CLASS,
  GET_AVAILABLE_INSTRUCTOR_SLOTS,
  GET_CATEGORY_DROPDOWN,
  GET_INSTRUCTOR_DROPDOWN,
  UPDATE_DAYLIGHT_CLASS,
  UPDATE_INSTRUCTOR_SLOTS,
} from "../../../Utlis/apiPath";
import { getApi, postApi, putApi } from "../../../Utlis/apiService";
import { errorToast, successToast } from "../../../Services/ToastHelper";
import { BackArrowIcon } from "../../../Components/Icons/BackArrowIcon";
import InstructorForm from "../../Instructor/InstructorForm/InstructorForm";
import Loader from "../../../Components/Loader/Loader";
import CategoryManagementForm from "../../CategoryManagement/CategoryManagementForm/CategoryManagementForm";
const { Option } = Select;
const { Title, Paragraph } = Typography;
const { RangePicker } = DatePicker;
const { TabPane } = Tabs;

const DaylightClassForm = ({
  setAddClassForm,
  fetchAllClasses,
  classEditedData,
}) => {
  const [editorContent, setEditorContent] = useState("");
  const [title, setTitle] = useState("");
  const [totalAttendence, setTotalAttendence] = useState(1);
  const [selectedOption, setSelectedOption] = useState("");
  const [classAddress, setClassAddress] = useState("");
  const [selectedCategory, setSelectedCategory] = useState();
  const [selectedInstructor, setSelectedInstructor] = useState();
  const [joiningLink, setJoiningLink] = useState("");
  // const [crop, setCrop] = useState({ unit: "%", width: 90, aspect: 1 });
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [price, setPrice] = useState("");
  const [comparePrice, setComparePrice] = useState("");
  const [usdPrice, setUsdPrice] = useState();
  const [compareUsdPrice, setCompareUsdPrice] = useState();
  const [weeklyprice, setWeeklyPrice] = useState("");
  const [weeklycomparePrice, setWeeklyComparePrice] = useState("");
  const [weeklyusdPrice, setWeeklyUsdPrice] = useState();
  const [weeklycompareUsdPrice, setWeeklyCompareUsdPrice] = useState();

  const [dateError, setDateError] = useState("");
  const [chargeTaxWeeklyInr, setChargeTaxWeeklyInr] = useState(false);
  const [chargeTaxWeeklyUsd, setChargeTaxWeeklyUsd] = useState(false);
  const [chargeTaxMonthlyInr, setChargeTaxMonthlyInr] = useState(false);
  const [chargeTaxMonthlyUsd, setChargeTaxMonthlyUsd] = useState(false);
  const [selectedValue, setSelectedValue] = useState("online");
  const [isLoading, setIsLoading] = useState(false);
  const [selectedInstructorId, setSelectedInstructorId] = useState(null);
  const [selectedGroup, setSelectedGroup] = useState();
  const [isChecked, setIsChecked] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [croppedImages, setCroppedImages] = useState([]);
  const fileInputRef = useRef(null);
  const [removedImageIds, setRemovedImageIds] = useState([]);
  const [newlyAddedSlots, setNewlyAddedSlots] = useState([]);
  const [removedSlotIds, setRemovedSlotIds] = useState([]);
  const [assignedSlots, setAssignedSlots] = useState();
  const [assignedSlotId, setAssignedSlotsId] = useState();
  const [subscriptionPrice, setSubscriptionPrice] = useState(null);
  const [selectedCategoryIds, setSelectedCategoryIds] = useState([]);
  const [slotIds, setSlotIds] = useState([]);
  const [selectedSlotIds, setSelectedSlotIds] = useState([]);
  const [newlycreatedSlotIds, setNewlycreatedSlotIds] = useState();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const cropperRef = useRef(null);
  const [crop, setCrop] = useState({
    unit: "px", // Use pixels
    width: 200, // Set fixed width
    height: 200, // Set fixed height
    x: 50,
    y: 50,
  });
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  // Each day tracks 4 independent buckets: standard/daylight x online/offline
  const createEmptySlotBucket = () => ({ isActive: false, slots: [] });
  const createEmptyDaySchedule = () => ({
    standard: { online: createEmptySlotBucket(), offline: createEmptySlotBucket() },
    daylight: { online: createEmptySlotBucket(), offline: createEmptySlotBucket() },
  });
  const buildEmptySchedule = () => ({
    Monday: createEmptyDaySchedule(),
    Tuesday: createEmptyDaySchedule(),
    Wednesday: createEmptyDaySchedule(),
    Thursday: createEmptyDaySchedule(),
    Friday: createEmptyDaySchedule(),
    Saturday: createEmptyDaySchedule(),
    Sunday: createEmptyDaySchedule(),
  });
  const [schedule, setSchedule] = useState(buildEmptySchedule);
  // Which mode (standard/daylight) the schedule modal is currently showing
  const [activeSlotMode, setActiveSlotMode] = useState("daylight");
  // Manual slot inputs per day (store dayjs objects)
  const [newSlotInputs, setNewSlotInputs] = useState({
    Monday: { start: null, end: null },
    Tuesday: { start: null, end: null },
    Wednesday: { start: null, end: null },
    Thursday: { start: null, end: null },
    Friday: { start: null, end: null },
    Saturday: { start: null, end: null },
    Sunday: { start: null, end: null },
  });

  const resetNewSlotInputs = () => {
    setNewSlotInputs({
      Monday: { start: null, end: null },
      Tuesday: { start: null, end: null },
      Wednesday: { start: null, end: null },
      Thursday: { start: null, end: null },
      Friday: { start: null, end: null },
      Saturday: { start: null, end: null },
      Sunday: { start: null, end: null },
    });
  };
  const [addCategoryForm, setAddCategoryForm] = useState(false);
  const [addInstructorForm, setShowAddInstructorForm] = useState(false);

  // Helper to sort slots by start time (nulls last)
  const sortSlotsByStart = (slots) => {
    return [...(slots || [])].sort((a, b) => {
      if (!a?.start && !b?.start) return 0;
      if (!a?.start) return 1;
      if (!b?.start) return -1;
      return a.start.localeCompare(b.start);
    });
  };

  // Standard/Daylight tab switcher shown above the slot lists in the schedule modal
  const renderSlotModeSwitcher = () => (
    <div
      style={{
        display: "flex",
        border: "1px solid #d9d9d9",
        borderRadius: "6px",
        overflow: "hidden",
        width: "fit-content",
        marginBottom: "14px",
      }}
    >
      {["standard", "daylight"].map((tab) => {
        const isDisabled = tab === "standard";
        return (
          <button
            key={tab}
            type="button"
            disabled={isDisabled}
            onClick={() => !isDisabled && setActiveSlotMode(tab)}
            style={{
              padding: "4px 16px",
              fontSize: "13px",
              fontWeight: activeSlotMode === tab ? 600 : 400,
              background: activeSlotMode === tab ? "#000" : "#fff",
              color: isDisabled ? "#bbb" : activeSlotMode === tab ? "#fff" : "#333",
              border: "none",
              cursor: isDisabled ? "not-allowed" : "pointer",
              textTransform: "capitalize",
            }}
          >
            {tab.charAt(0).toUpperCase() + tab.slice(1)}
          </button>
        );
      })}
    </div>
  );

  useEffect(() => {
    if (selectedImage) {
      setCrop({
        unit: "px",
        width: 300,
        height: 300,
        x: 50,
        y: 50,
      });
    }
  }, [selectedImage]);

  const handleToggleSlot = (day, slot) => {
    const slotId = slot.id;

    setSelectedSlotIds((prev) => {
      if (prev.includes(slotId)) {
        // If already selected, remove it
        const updatedSlots = prev.filter((id) => id !== slotId);
        return updatedSlots;
      } else {
        // Otherwise, add it
        const updatedSlots = [...prev, slotId];
        return updatedSlots;
      }
    });
  };

  const isSlotSelected = (slotId) => selectedSlotIds.includes(slotId);

  const [newRemovedSlotIds, setNewRemovedSlotIds] = useState([]);
  const [unassignSlotIds, setUnassignSlotIds] = useState([]);

  const handleRemoveSlot = (day, slotId) => {
    setAssignedSlots((prevSlots) => {
      const updatedSlots = { ...prevSlots };
      updatedSlots[day] = updatedSlots[day].filter(
        (slot) => slot.id !== slotId
      );

      if (updatedSlots[day].length === 0) {
        delete updatedSlots[day];
      }

      setNewRemovedSlotIds((prevIds) => [...prevIds, slotId]);
      return updatedSlots;
    });
  };

  const handleToggleUnassign = (slotId) => {
    setUnassignSlotIds((prev) =>
      prev.includes(slotId) ? prev.filter((id) => id !== slotId) : [...prev, slotId]
    );
  };

  const weekdays = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ];


  const handleDateChange = (dates) => {
    if (dates && dates.length === 2) {
      setStartDate(dates[0]);
      setEndDate(dates[1]);
      setDateError(""); // Clear error when valid dates are selected
    } else {
      setStartDate(null);
      setEndDate(null);
      setDateError("Please select a valid date range.");
    }
  };

  const updateSchedule = (start, end) => {
    if (!start || !end) return;

    const startDay = dayjs(start).day();
    const endDay = dayjs(end).day();

    const filteredSchedule = {};

    weekdays.forEach((day, index) => {
      if (
        (startDay <= endDay && index >= startDay && index <= endDay) ||
        (startDay > endDay && (index >= startDay || index <= endDay))
      ) {
        filteredSchedule[day] = schedule[day]
          ? { ...schedule[day] }
          : createEmptyDaySchedule();
      }
    });

    setSchedule(filteredSchedule);
  };

  useEffect(() => {
    updateSchedule(startDate, endDate);
  }, [startDate, endDate, classEditedData, isModalVisible]);

  useEffect(() => {
    if (classEditedData) {
      const data = classEditedData[0];
      setTitle(data.title || "");
      setEditorContent(data.description || "");
      setPrice(data.monthlyPrice || "");
      setComparePrice(data.monthlyCompareAtPrice || "");
      setCompareUsdPrice(data.monthlyCompareUsdPrice || "");
      setUsdPrice(data.monthlyUsdPrice || "");
      setWeeklyPrice(data.weeklyPrice || "");
      setWeeklyComparePrice(data.weeklyCompareAtPrice || "");
      setWeeklyCompareUsdPrice(data.weeklyCompareUsdPrice || "");
      setWeeklyUsdPrice(data.weeklyUsdPrice || "");
      setEndDate(dayjs(data.hourlyenddate || ""));
      setStartDate(dayjs(data.hourlystartdate || ""));
      setChargeTaxWeeklyInr(data.chargeTax ?? data.chargeTaxWeeklyInr ?? false);
      setChargeTaxWeeklyUsd(data.chargeTaxWeeklyUsd || false);
      setChargeTaxMonthlyInr(data.chargeTaxMonthlyInr || false);
      setChargeTaxMonthlyUsd(data.chargeTaxMonthlyUsd || false);
      setSelectedOption(data.bookingType || "");
      setClassAddress(data.classAddress || "");
      setSelectedValue(data.joinType || null);
      setJoiningLink(data.joiningLink || "");
      setTotalAttendence(data.totalAttendees || "");
      setSubscriptionPrice(data.subscription || "");
      setIsChecked(data.addReview || false);
      setSelectedCategoryIds(
        data.categories?.map((category) => category.id) || []
      );
      setSelectedInstructorId(data.instructor?.id || null);
      setSelectedGroup(data.classType || null);

      setDuration({
        hours: `${data.durationHour || 0} Hour`,
        minutes: `${data.durationMunite || 0} minutes`,
      });
      setBuffer({
        hours: `${data.bufferHour || 0} Hour`,
        minutes: `${data.bufferMunite || 0} minutes`,
      });

      const mappedImages = (data.classImages || []).map((media) => ({
        type: "existing",
        id: media.id,
        url: `${media.url}`,
      }));
      setCroppedImages(mappedImages);
      const groupedSlots = data?.slots?.reduce((acc, slot) => {
        if (!acc[slot.day]) {
          acc[slot.day] = [];
        }
        acc[slot.day].push({
          id: slot.id,
          startTime: slot.startTime,
          endTime: slot.endTime,
        });
        return acc;
      }, {});

      setAssignedSlots(groupedSlots);
      const slotIds = Object.values(groupedSlots)
        .flat()
        .map((slot) => slot.id);
      setAssignedSlotsId(slotIds);
    }
  }, [classEditedData]);

  const [duration, setDuration] = useState({
    hours: "0 Hour",
    minutes: "57 minutes",
  });

  const [buffer, setBuffer] = useState({
    hours: "0 Hour",
    minutes: "30 minutes",
  });

  const [errors, setErrors] = useState({
    title: "",
    editorContent: "",
    price: "",
    usdPrice: "",
    comparePrice: "",
    compareUsdPrice: "",
    totalAttendence: "",
    customerSchedule: "",
    joiningLink: "",
    selectedInstructorId: "",
    selectedCategoryIds: "",
    selectedValue: "",
    classAddress: "",
    selectedGroup: "",
  });

  const isDescriptionEmpty = (html) => {
    if (!html) return true;
    const trimmed = String(html).trim();
    const knownEmpty = ["<p><br></p>", "<p>&nbsp;</p>", "<p></p>"];
    if (knownEmpty.includes(trimmed)) return true;
    const text = trimmed
      .replace(/<[^>]*>/g, "")
      .replace(/&nbsp;/g, " ")
      .trim();
    return text.length === 0;
  };

  // Scroll to the first errored field (using selector mapping since we don't use antd Form here)
  const scrollToErrorFromErrors = (errs) => {
    const order = [
      "title",
      "editorContent",
      "selectedCategoryIds",
      "selectedInstructorId",
      "price",
      "comparePrice",
      "usdPrice",
      "compareUsdPrice",
      "selectedGroup",
      "classAddress",
      "joiningLink",
      "totalAttendence",
    ];

    const selectors = {
      title: 'input[placeholder="Class Title"]',
      editorContent: '.ql-editor',
      selectedCategoryIds: '[name="category"]',
      selectedInstructorId: '[name="instructor"]',
      price: 'input[placeholder="00.00"]',
      comparePrice: 'input[placeholder="00.00"]',
      usdPrice: 'input[placeholder="$ 00.00"]',
      compareUsdPrice: 'input[placeholder="$ 00.00"]',
      selectedGroup: '[name="mode"]',
      classAddress: 'input[placeholder="Enter class address"]',
      joiningLink: 'input[placeholder="Enter meeting link"]',
      totalAttendence: 'input[placeholder="00"]',
    };

    const firstKey = order.find((k) => errs?.[k]);
    if (!firstKey) return;

    const selector = selectors[firstKey];
    if (!selector) return;

    const el = document.querySelector(selector);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'nearest' });
      setTimeout(() => {
        if (typeof el.focus === 'function') el.focus();
      }, 300);
    }
  };

  const handleInstructorChange = (value) => {
    setAssignedSlots();
    setAssignedSlotsId();
    setSelectedInstructorId(value);

    // fetchInstructorSlots(value);
    // setIsModalVisible(true);
  };

  const handleReviewChange = (e) => {
    setIsChecked(e.target.checked);
  };

  const handleToggle = (day, mode, slotType) => {
    setSchedule((prev) => {
      const isCurrentlyActive = prev[day][mode][slotType].isActive;

      if (isCurrentlyActive) {
        const idsToRemove = prev[day][mode][slotType].slots
          .map((slot) => slot.id)
          .filter(Boolean);
        if (idsToRemove.length > 0) {
          setNewRemovedSlotIds((prevIds) => [...prevIds, ...idsToRemove]);
        }
      }

      return {
        ...prev,
        [day]: {
          ...prev[day],
          [mode]: {
            ...prev[day][mode],
            [slotType]: {
              ...prev[day][mode][slotType],
              isActive: !isCurrentlyActive,
            },
          },
        },
      };
    });
  };

  // Helper: check conflict with a strict 1-minute gap on both sides
  const hasConflictWithMinuteGap = (day, mode, slotType, startStr, endStr) => {
    const newStart = dayjs(startStr, "HH:mm");
    const newEnd = dayjs(endStr, "HH:mm");

    return schedule[day][mode][slotType].slots.some((slot) => {
      if (!slot.start || !slot.end) return false;
      const slotStart = dayjs(slot.start, "HH:mm");
      const slotEnd = dayjs(slot.end, "HH:mm");
      // Require at least 1-minute gap: allow exactly 1-minute gap
      // noConflict if newEnd <= slotStart - 1min OR newStart >= slotEnd + 1min
      const leftBoundary = slotStart.subtract(1, "minute");
      const rightBoundary = slotEnd.add(1, "minute");
      const noConflict =
        newEnd.isBefore(leftBoundary) || newEnd.isSame(leftBoundary) ||
        newStart.isAfter(rightBoundary) || newStart.isSame(rightBoundary);
      return !noConflict;
    });
  };

  // Manual add slot using inputs for the given day
  const handleAddManualSlot = (day, mode, slotType) => {
    const startTime = newSlotInputs[day]?.start;
    const endTime = newSlotInputs[day]?.end;

    if (!startTime || !endTime) {
      errorToast("Please select both start and end times.");
      return;
    }

    const startStr = dayjs(startTime).format("HH:mm");
    const endStr = dayjs(endTime).format("HH:mm");

    // Validate ordering: strictly increasing
    if (!dayjs(endStr, "HH:mm").isAfter(dayjs(startStr, "HH:mm"))) {
      errorToast("End time must be strictly after start time.");
      return;
    }

    // Check conflict with 1-minute gap rule
    if (hasConflictWithMinuteGap(day, mode, slotType, startStr, endStr)) {
      errorToast(
        "Slot conflicts with existing ones. Maintain a 1-minute gap before/after."
      );
      return;
    }

    setSchedule((prev) => {
      const updatedSlots = [
        ...prev[day][mode][slotType].slots,
        { start: startStr, end: endStr },
      ].sort((a, b) => dayjs(a.start, "HH:mm").diff(dayjs(b.start, "HH:mm")));

      return {
        ...prev,
        [day]: {
          ...prev[day],
          [mode]: {
            ...prev[day][mode],
            [slotType]: { ...prev[day][mode][slotType], slots: updatedSlots },
          },
        },
      };
    });

    // clear inputs
    setNewSlotInputs((prev) => ({
      ...prev,
      [day]: { start: null, end: null },
    }));
  };

  const handleTimeChange = (day, index, time, field, mode, slotType) => {
    setSchedule((prev) => {
      let updatedSlots = [...prev[day][mode][slotType].slots];
      let newTime = time.format("HH:mm");

      // Update the selected time
      updatedSlots[index] = { ...updatedSlots[index], [field]: newTime };

      // Sort slots after updating
      updatedSlots.sort((a, b) =>
        dayjs(a.start, "HH:mm").diff(dayjs(b.start, "HH:mm"))
      );

      // Check for overlapping slots with mandatory 1-minute gap and no touching
      for (let i = 0; i < updatedSlots.length - 1; i++) {
        let currentEnd = dayjs(updatedSlots[i].end, "HH:mm");
        let nextStart = dayjs(updatedSlots[i + 1].start, "HH:mm");

        // Require currentEnd + 1 minute <= nextStart
        if (currentEnd.add(1, "minute").isAfter(nextStart)) {
          errorToast(
            "Slots must have at least a 1-minute gap and cannot touch."
          );
          return prev;
        }
      }

      return {
        ...prev,
        [day]: {
          ...prev[day],
          [mode]: {
            ...prev[day][mode],
            [slotType]: { ...prev[day][mode][slotType], slots: updatedSlots },
          },
        },
      };
    });
  };

  const removeTimeSlot = (day, index, mode, slotType) => {
    setSchedule((prev) => {
      const slotToRemove = prev[day][mode][slotType].slots[index];
      const updatedSlots = prev[day][mode][slotType].slots.filter(
        (_, i) => i !== index
      );

      if (slotToRemove?.id) {
        setNewRemovedSlotIds((prevIds) => [...prevIds, slotToRemove.id]);
      }

      return {
        ...prev,
        [day]: {
          ...prev[day],
          [mode]: {
            ...prev[day][mode],
            [slotType]: { ...prev[day][mode][slotType], slots: updatedSlots },
          },
        },
      };
    });
  };

  const handleSave = async () => {
    if (selectedOption === "hourly" && (!startDate || !endDate)) {
      setDateError("Start Date and End Date are required.");
      return;
    }

    setIsModalVisible(false);
    resetNewSlotInputs();

    if (newlyAddedSlots.length > 0 || newRemovedSlotIds.length > 0 || unassignSlotIds.length > 0) {
      // Pass a copy of unassignSlotIds to prevent it from being cleared too early
      await UpdateInstructorSlots([...unassignSlotIds]);
    }
  };

  const hoursOptions = Array.from({ length: 25 }, (_, i) => `${i} Hour`);
  const DurationHoursOptions = ["0 Hour", "1 Hour"];
  const minutesOptions = Array.from({ length: 60 }, (_, i) => `${i} minutes`);

  const renderSelect = (value, onChange, options) => (
    <Select value={value} onChange={onChange} style={{ width: 120 }}>
      {options.map((opt) => (
        <Option key={opt} value={opt}>
          {opt}
        </Option>
      ))}
    </Select>
  );

  const handleDurationChange = (field, value) => {
    const updatedDuration = { ...duration, [field]: value };
    setDuration(updatedDuration);
  };

  const handleBufferChange = (field, value) => {
    const updatedBuffer = { ...buffer, [field]: value };
    setBuffer(updatedBuffer);
  };

  const handleClassAddressChange = (e) => {
    setClassAddress(e.target.value);
  };

  const options2 = [
    { id: "group", name: "Group" },
    { id: "one-on-one", name: "One On One" },
    { id: "premium", name: "Premium" },
    { id: "custom", name: "Custom" },
  ];

  const handleClassTypeChange = (value) => {
    if (value === "one-on-one") {
      setTotalAttendence(1);
      setSelectedGroup(value);
    } else {
      setSelectedGroup(value);
    }
  };

  const hanldeBack = () => {
    setAddClassForm(false);
  };

  const validateFields = () => {
    let valid = true;
    const newErrors = { ...errors };

    // Mandatory Fields Validation
    if (!title) {
      newErrors.title = "Title is required.";
      valid = false;
    } else {
      newErrors.title = "";
    }

    if (isDescriptionEmpty(editorContent)) {
      newErrors.editorContent = "Description is required.";
      valid = false;
    } else {
      newErrors.editorContent = "";
    }

    if (!price) {
      newErrors.price = "Price is required.";
      valid = false;
    } else {
      newErrors.price = "";
    }
    if (!selectedValue) {
      newErrors.selectedValue = "Join Type is required.";
      valid = false;
    } else {
      newErrors.selectedValue = "";
    }

    if (!comparePrice) {
      newErrors.comparePrice = "Compare-at price is required.";
      valid = false;
    } else {
      newErrors.comparePrice = "";
    }
    if (!usdPrice) {
      newErrors.usdPrice = "usd Price price is required.";
      valid = false;
    } else {
      newErrors.usdPrice = "";
    }
    if (!compareUsdPrice) {
      newErrors.compareUsdPrice = "compare Usd Price price is required.";
      valid = false;
    } else {
      newErrors.compareUsdPrice = "";
    }

    // Discounted price must not exceed the Compare-at (MRP) price
    if (
      weeklyprice &&
      weeklycomparePrice &&
      parseFloat(weeklyprice) > parseFloat(weeklycomparePrice)
    ) {
      newErrors.weeklyPriceCompare =
        "Discounted price cannot be greater than Compare-at price (MRP).";
      valid = false;
    } else {
      newErrors.weeklyPriceCompare = "";
    }

    if (
      weeklyusdPrice &&
      weeklycompareUsdPrice &&
      parseFloat(weeklyusdPrice) > parseFloat(weeklycompareUsdPrice)
    ) {
      newErrors.weeklyUsdPriceCompare =
        "Discounted price cannot be greater than Compare-at price (MRP).";
      valid = false;
    } else {
      newErrors.weeklyUsdPriceCompare = "";
    }

    if (price && comparePrice && parseFloat(price) > parseFloat(comparePrice)) {
      newErrors.monthlyPriceCompare =
        "Discounted price cannot be greater than Compare-at price (MRP).";
      valid = false;
    } else {
      newErrors.monthlyPriceCompare = "";
    }

    if (
      usdPrice &&
      compareUsdPrice &&
      parseFloat(usdPrice) > parseFloat(compareUsdPrice)
    ) {
      newErrors.monthlyUsdPriceCompare =
        "Discounted price cannot be greater than Compare-at price (MRP).";
      valid = false;
    } else {
      newErrors.monthlyUsdPriceCompare = "";
    }

    if (!selectedInstructorId) {
      newErrors.assignStaff = "Assigning staff is required.";
      valid = false;
    } else {
      newErrors.assignStaff = "";
    }

    if (!selectedCategoryIds.length > 0) {
      newErrors.selectedCategoryIds = "Category is required.";
      valid = false;
    } else {
      newErrors.selectedCategoryIds = "";
    }

    if (!selectedGroup) {
      newErrors.selectedGroup = "Class type is required."; // Set error under selectedGroup
      valid = false;
    } else {
      newErrors.selectedGroup = "";
    }
    setErrors(newErrors);
    if (!valid) {
      scrollToErrorFromErrors(newErrors);
    }
    return valid;
  };

  useEffect(() => {
    fetchCategoryDropDown();
  }, [addCategoryForm]);

  const fetchCategoryDropDown = async () => {
    setIsLoading(true);
    try {
      const url = `${GET_CATEGORY_DROPDOWN}`;
      const { status, message, data } = await getApi(url);
      if (status === 200) {
        setSelectedCategory(data);
      } else {
        setSelectedCategory([]);
      }
    } catch (error) {
      console.error("Error fetching classes:", error);
      setSelectedCategory([]);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchInstructorDropDown();
  }, [addInstructorForm]);

  const fetchInstructorDropDown = async () => {
    setIsLoading(true);
    try {
      const url = `${GET_INSTRUCTOR_DROPDOWN}`;
      const { status, message, data } = await getApi(url);
      if (status === 200) {
        setSelectedInstructor(data);
      } else {
        setSelectedInstructor([]);
      }
    } catch (error) {
      console.error("Error fetching classes:", error);
      setSelectedInstructor([]);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchInstructorSlots = async (id) => {
    setIsLoading(true);
    try {
      const [standardRes, daylightRes] = await Promise.all([
        getApi(GET_AVAILABLE_INSTRUCTOR_SLOTS, { params: { instructorId: id, mode: "standard" } }),
        getApi(GET_AVAILABLE_INSTRUCTOR_SLOTS, { params: { instructorId: id, mode: "daylight" } }),
      ]);
      const standardData = standardRes.status === 200 ? standardRes.data : [];
      const daylightData = daylightRes.status === 200 ? daylightRes.data : [];
      setSlotIds([...standardData, ...daylightData].map((slot) => slot.id));
      patchScheduleData(standardData, daylightData);
    } finally {
      setIsLoading(false);
    }
  };

  const SLOT_TYPE_BY_KEY = { online: 1, offline: 2 };

  useEffect(() => {
    const formattedArray = Object.entries(schedule).reduce(
      (acc, [day, dayData]) => {
        ["standard", "daylight"].forEach((mode) => {
          ["online", "offline"].forEach((slotTypeKey) => {
            const bucketSlots = dayData[mode][slotTypeKey].slots;
            const newSlots = bucketSlots.filter((slot) => !slot.id); // only slots without an id are "new"

            if (newSlots.length > 0) {
              acc.push({
                days: day,
                startEndTime: newSlots.map((slot) => ({
                  startTime: slot.start,
                  endTime: slot.end,
                  slotType: SLOT_TYPE_BY_KEY[slotTypeKey],
                  isDaylight: mode === "daylight",
                })),
              });
            }
          });
        });
        return acc;
      },
      []
    );

    setNewlyAddedSlots(formattedArray);
  }, [schedule]);

  const UpdateInstructorSlots = async (unassignSlotIdsToUse = []) => {
    setIsLoading(true);

    try {
      const payload = {
        instructorId: selectedInstructorId,
        slots: newlyAddedSlots || [],
        prevSlotIds: newRemovedSlotIds || [],
        unassignSlotIds: unassignSlotIdsToUse,
      };

      const { status, data } = await postApi(UPDATE_INSTRUCTOR_SLOTS, payload);
      
      if (data?.newSlots) {
        const ids = data.newSlots.map((slot) => slot.id);
        setNewlycreatedSlotIds(ids);
      }

      if (status === 200) {
        await fetchInstructorSlots(selectedInstructorId);
        setNewlyAddedSlots([]);
        // Only reset unassignSlotIds if we're not in the middle of an update
        if (unassignSlotIdsToUse.length === 0) {
          setUnassignSlotIds([]);
        }
      }
    } catch (error) {
      console.error("Error updating instructor slots:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const patchScheduleData = (standardData, daylightData) => {
    const updatedSchedule = buildEmptySchedule();

    const applyData = (slotsData, mode) => {
      slotsData.forEach((slot) => {
        const day = slot.day;
        if (!updatedSchedule[day]) return;

        const slotTypeKey = slot.slotType === 1 ? "online" : "offline";
        const bucket = updatedSchedule[day][mode][slotTypeKey];

        bucket.isActive = true;
        bucket.slots.push({
          id: slot.id,
          start: slot.startTime,
          end: slot.endTime,
        });
      });
    };

    applyData(standardData, "standard");
    applyData(daylightData, "daylight");

    // Sort slots per bucket by start time
    Object.keys(updatedSchedule).forEach((day) => {
      ["standard", "daylight"].forEach((mode) => {
        ["online", "offline"].forEach((slotTypeKey) => {
          const bucket = updatedSchedule[day][mode][slotTypeKey];
          bucket.slots = sortSlotsByStart(bucket.slots);
        });
      });
    });
    setSchedule(updatedSchedule);
  };

  const handleFileSelect = (e) => {
    if (croppedImages.length >= 4) {
      errorToast("You can only upload up to 4 images.");
      return;
    }

    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = () => {
        setSelectedImage(reader.result);
        fileInputRef.current.value = ""; // Reset file input to allow re-selection of same file
      };
      reader.readAsDataURL(file);
    }
  };

  const handleRemoveImage = (index) => {
    setCroppedImages((prev) => {
      const updatedImages = [...prev];
      const removedImage = updatedImages.splice(index, 1)[0];

      if (removedImage.type === "existing") {
        setRemovedImageIds((prevIds) => [...prevIds, removedImage?.id]); // Add ID to removedImageIds
      }

      return updatedImages;
    });
  };

  const handleSlotsVisible = () => {
    updateSchedule(startDate, endDate);
    resetNewSlotInputs();
    setIsModalVisible(true);
    fetchInstructorSlots(selectedInstructorId);
  };

  useEffect(() => {
    fetchInstructorSlots(selectedInstructorId);
  }, [selectedInstructorId]);

  const handleSaveButtonClick = async () => {
    if (validateFields()) {
      setIsLoading(true);

      try {
        const formData = new FormData();
        formData.append("title", title);
        formData.append("description", editorContent);
        formData.append("categoryIds", selectedCategoryIds);
        formData.append("currency", "USD");
        formData.append("price", parseFloat(price));
        formData.append("usdPrice", parseFloat(usdPrice));
        formData.append("compareAtPrice", parseFloat(comparePrice));
        formData.append("compareUsdPrice", parseFloat(compareUsdPrice));
        formData.append("weeklyPrice", parseFloat(weeklyprice));
        formData.append("weeklyUsdPrice", parseFloat(weeklyusdPrice));
        formData.append("weeklyCompareAtPrice", parseFloat(weeklycomparePrice));
        formData.append(
          "weeklyCompareUsdPrice",
          parseFloat(weeklycompareUsdPrice)
        );

        formData.append("chargeTax", chargeTaxWeeklyInr);
        formData.append("joinType", selectedValue);
        formData.append("classType", selectedGroup);

        formData.append(
          "hourlystartdate",
          new Date(startDate).toLocaleDateString("en-CA")
        );
        formData.append(
          "hourlyenddate",
          new Date(endDate).toLocaleDateString("en-CA")
        );

        formData.append("bookingType", "monthly");
        formData.append("status", "upcoming");
        formData.append("joiningLink", joiningLink);
        formData.append("classAddress", classAddress);
        formData.append("instructorId", selectedInstructorId);
        formData.append("totalAttendees", totalAttendence);
        formData.append("subscription", subscriptionPrice);
        formData.append("durationHour", duration.hours.split(" ")[0]);
        //bufferMunite, durationMunite is used instead of bufferMinute. durationMinute at this place and all the other to match the api specs (there is a typon in backend api payload)
        formData.append("durationMunite", duration.minutes.split(" ")[0]);
        formData.append("bufferHour", buffer.hours.split(" ")[0]);
        formData.append("bufferMunite", buffer.minutes.split(" ")[0]);
        formData.append("addReview", isChecked);

        const allSlotIds = [
          ...(selectedSlotIds || []),
          ...(newlycreatedSlotIds || []),
        ];
        formData.append("slots", allSlotIds);

        croppedImages.forEach((image, index) => {
          if (image.type === "new") {
            formData.append(`imageUpload`, image.blob, `image_${index}.jpeg`);
          }
        });
        const response = await postApi(ADD_NEW_DAYLIGHT_CLASS, formData, {
          headers: { "Content-Type": "multipart/form-data" },
        });

        const { status, message } = response;

        if (status === 200) {
          successToast(message);
          setAddClassForm(false);
          fetchAllClasses();

          // Reset fields
          setTitle("");
          setEditorContent("");
          setPrice("");
          setComparePrice("");
          setCompareUsdPrice("");
          setUsdPrice("");
          setChargeTaxWeeklyInr(false);
          setChargeTaxWeeklyUsd(false);
          setChargeTaxMonthlyInr(false);
          setChargeTaxMonthlyUsd(false);
          setSelectedValue("");
          setSelectedOption("");
          setJoiningLink("");
          setTotalAttendence("");
          setDuration({ hours: "0 hours", minutes: "0 minutes" });
          setBuffer({ hours: "0 hours", minutes: "0 minutes" });
          setIsChecked(false);
          setSchedule({});
          setEndDate(null);
          setStartDate(null);
        } else {
          errorToast(message);
        }
      } catch (error) {
        errorToast("An error occurred while saving the class.");
      } finally {
        setIsLoading(false);
      }
    }
  };

  const handleUpdateButtonClick = async () => {
    
    // Store the current unassignSlotIds in a constant to prevent it from changing
    const currentUnassignSlotIds = [...unassignSlotIds];
    
    if (validateFields()) {
      setIsLoading(true);

      try {
        const formData = new FormData();

        // Add basic fields
        formData.append("classId", classEditedData[0].id);
        formData.append("title", title);
        formData.append("description", editorContent);
        formData.append("categoryIds", selectedCategoryIds);
        formData.append("price", parseFloat(price));
        formData.append("currency", "USD");
        formData.append("usdPrice", parseFloat(usdPrice));
        formData.append("compareAtPrice", parseFloat(comparePrice));
        formData.append("compareUsdPrice", parseFloat(compareUsdPrice));
        formData.append("weeklyPrice", parseFloat(weeklyprice));
        formData.append("weeklyCompareAtPrice", parseFloat(weeklycomparePrice));
        formData.append("weeklyUsdPrice", parseFloat(weeklyusdPrice));
        formData.append(
          "weeklyCompareUsdPrice",
          parseFloat(weeklycompareUsdPrice)
        );

        formData.append("chargeTax", chargeTaxWeeklyInr);
        formData.append("joinType", selectedValue);
        formData.append("classType", selectedGroup);
        formData.append(
          "hourlystartdate",
          new Date(startDate).toLocaleDateString("en-CA")
        );
        formData.append(
          "hourlyenddate",
          new Date(endDate).toLocaleDateString("en-CA")
        );
        formData.append("bookingType", "monthly");
        formData.append("status", "UPCOMING");
        formData.append("joiningLink", joiningLink);
        formData.append("classAddress", classAddress);
        formData.append("instructorId", selectedInstructorId);
        formData.append("totalAttendees", totalAttendence);
        formData.append("subscription", subscriptionPrice);
        formData.append("durationHour", duration.hours.split(" ")[0]);
        formData.append("durationMunite", duration.minutes.split(" ")[0]);
        formData.append("bufferHour", buffer.hours.split(" ")[0]);
        formData.append("bufferMunite", buffer.minutes.split(" ")[0]);
        formData.append("addReview", isChecked);
        
        // Use the stored unassigned slot IDs
        const finalUnassignedSlotIds = currentUnassignSlotIds || [];
        
        // Send removed slot IDs to the server
        formData.append("removeSlotIds", newRemovedSlotIds);

        // Function to filter out unassigned slots
        const filterOutUnassignedSlots = (ids) => 
          ids ? ids.filter(id => !finalUnassignedSlotIds.includes(id)) : [];

        // Get all slot IDs that should be assigned
        const allSlotIds = [
          ...filterOutUnassignedSlots(assignedSlotId || []),
          ...filterOutUnassignedSlots(selectedSlotIds || []),
          ...filterOutUnassignedSlots(newlycreatedSlotIds || [])
        ].filter(id => !newRemovedSlotIds.includes(id)); // Also filter out any removed slots

        formData.append("slots", allSlotIds);

        // Append new images
        croppedImages.forEach((image, index) => {
          if (image.type === "new") {
            formData.append(`imageUpload`, image.blob, `image_${index}.jpeg`);
          }
        });
        const previousImageIds = [...new Set(removedImageIds)].join(",");

        if (previousImageIds) {
          formData.append("previousImageIds", previousImageIds);
        }
        const response = await putApi(UPDATE_DAYLIGHT_CLASS, formData, {
          headers: { "Content-Type": "multipart/form-data" },
        });
        const { status, message } = response;

        if (status === 200) {
          successToast(message);
          setAddClassForm(false);
          fetchAllClasses();

          // Reset fields
          setTitle("");
          setEditorContent("");
          setPrice("");
          setComparePrice("");
          setUsdPrice("");
          setChargeTaxWeeklyInr(false);
          setChargeTaxWeeklyUsd(false);
          setChargeTaxMonthlyInr(false);
          setChargeTaxMonthlyUsd(false);
          setSelectedValue("");
          setSelectedOption("");
          setJoiningLink("");
          setTotalAttendence("");
          setDuration({ hours: "0 hours", minutes: "0 minutes" });
          setBuffer({ hours: "0 hours", minutes: "0 minutes" });
          setIsChecked(false);
          setSchedule({});
          setEndDate(null);
          setStartDate(null);
        } else {
          errorToast(message);
        }
      } catch (error) {
        errorToast("An error occurred while updating the class.");
      } finally {
        setIsLoading(false);
      }
    }
  };

  const handleModalCancel = () => {
    setIsModalOpen(false);
    setSelectedImage(null);
  };

  const handleSubmit = () => {
    handleCropComplete();
    setIsModalOpen(false);
  };

  const handleCropComplete = async () => {
    if (cropperRef.current) {
      const cropper = cropperRef.current.cropper;
      cropper.getCroppedCanvas().toBlob((blob) => {
        if (blob) {
          setCroppedImages((prev) => [...prev, { type: "new", blob }]);
          setSelectedImage(null);
        }
      }, "image/jpeg");
    }
  };

  const handleImageChange = (event) => {
    if (event.target.files && event.target.files.length > 0) {
      const newImage = event.target.files[0];

      const reader = new FileReader();
      reader.onload = (event) => {
        setSelectedImage(event.target.result);
        setIsModalOpen(true);
      };
      reader.readAsDataURL(newImage);
      event.target.value = null;
    }
  };

  const handleAddCategory = () => {
    setAddCategoryForm(true);
  };

  const handleSaves = () => {
    // save logic here
    // setAddCategoryForm(false);
  };

  const handleAddInstructor = () => {
    setShowAddInstructorForm(true);
  };

  return (
    <>
      <div className="addcls">
        {isLoading && <Loader />}
        <div className="addcls_cont">
          <div className="addcls_cont_header">
            <h2
              style={{
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                gap: "10px",
              }}
              onClick={hanldeBack}
            >
              <BackArrowIcon />
              Day Light Class
            </h2>
          </div>

          <Card style={{ marginBottom: "10px" }} className="addcls_cont_form">
            <div className="form-group">
              <span className="heading_h1" style={{ fontSize: 16, fontWeight: 600}}>
                Class Details
              </span>
              <label>Title*</label>
              <FormInputs
                type="text"
                placeholder="Class Title"
                className="title-input"
                value={title}
                onChange={(e) => {
                  setTitle(e.target.value);
                  setErrors((prevErrors) => ({
                    ...prevErrors,
                    title: e.target.value ? "" : prevErrors.title,
                  }));
                }}
              />
              {errors.title && <span className="error">{errors.title}</span>}
            </div>

            <div className="form-group">
              <label>Description*</label>
              <ReactQuill
                theme="snow"
                value={editorContent}
                onChange={(value) => {
                  setEditorContent(value);
                  setErrors((prevErrors) => ({
                    ...prevErrors,
                    editorContent: isDescriptionEmpty(value)
                      ? "Description is required."
                      : "",
                  }));
                }}
                placeholder="Write your class description here..."
              />
              {errors.editorContent && (
                <p className="error">{errors.editorContent}</p>
              )}
            </div>

            <div className="form-group">
              <label>Media</label>
              <div className="media-section">
                <div className="media-preview">
                  {croppedImages.map((image, index) => (
                    <div key={index} className="image-preview-cont">
                      <div className="uploaded-image">
                        {image.type === "existing" ? (
                          <img src={image?.url} alt="Preview" />
                        ) : (
                          <img
                            src={URL.createObjectURL(image.blob)}
                            alt="Preview"
                          />
                        )}
                      </div>
                      <button
                        className="remove-image"
                        onClick={() => handleRemoveImage(index)}
                        aria-label="Remove Image"
                      >
                        {/* <i className="fas fa-times"></i>  */}X
                      </button>
                    </div>
                  ))}
                </div>
                <div className="media-upload">
                  <input
                    ref={fileInputRef}
                    type="file"
                    accept="image/*"
                    onChange={handleFileSelect}
                    style={{ display: "none" }}
                  />
                  <button
                    className="upload-button"
                    onClick={() => fileInputRef.current?.click()}
                    // disabled={croppedImages.length >= 4}
                  >
                    +
                  </button>
                </div>
              </div>
            </div>

            <Modal
              title="Crop Image"
              open={isModalOpen}
              onCancel={handleModalCancel}
              maskClosable={false}
              width={700}
              footer={[
                <Button key="back" onClick={handleModalCancel}>
                  Cancel
                </Button>,
                <Button key="submit" type="primary" onClick={handleSubmit}>
                  Submit
                </Button>,
              ]}
            >
              {selectedImage && (
                <Cropper
                  src={selectedImage}
                  style={{ height: 400, width: "100%" }}
                  initialAspectRatio={1}
                  aspectRatio={1.5}
                  guides={true}
                  ref={cropperRef}
                  viewMode={1}
                  dragMode="move"
                  scalable={true}
                  cropBoxResizable={true}
                  cropBoxMovable={true}
                />
              )}
            </Modal>
            <input
              ref={fileInputRef}
              accept=".jpeg, .jpg, .png, .webp"
              type="file"
              onChange={handleImageChange}
              style={{ display: "none" }}
            />
            <div
              className="form-group"
              style={{ display: "flex", gap: "16px", alignItems: "center" }}
            >
              <div className="form-group">
                <label style={{ display: "block", marginBottom: "8px" }}>
                  Select category *
                </label>
                <div
                  className="category-section"
                  style={{
                    display: "flex",
                    gap: "16px",
                    alignItems: "center",
                    minWidth: "12vw", // Initial width
                    width: "fit-content", // Expands based on content
                  }}
                >
                  <Select
                    mode="multiple"
                    placeholder="Select category"
                    name="category"
                    size="large"
                    value={selectedCategoryIds}
                    dropdownRender={(menu) => (
                      <div>
                        <div style={{ display: 'flex', justifyContent: 'space-between', padding: '4px 8px' }}>
                          <Button type="link" onClick={() => {
                            const allIds = (selectedCategory || []).map((c) => c.id);
                            setSelectedCategoryIds(allIds);
                            setErrors((prevErrors) => ({
                              ...prevErrors,
                              selectedCategoryIds: allIds.length > 0 ? "" : prevErrors.selectedCategoryIds,
                            }));
                          }}>
                            Select All
                          </Button>
                          <Button type="link" onClick={() => {
                            setSelectedCategoryIds([]);
                          }}>
                            Clear All
                          </Button>
                        </div>
                        <Divider style={{ margin: '4px 0' }} />
                        {menu}
                      </div>
                    )}
                    onChange={(values) => {
                      setSelectedCategoryIds(values);
                      setErrors((prevErrors) => ({
                        ...prevErrors,
                        selectedCategoryIds:
                          values.length > 0
                            ? ""
                            : prevErrors.selectedCategoryIds,
                      }));
                    }}
                    style={{ width: "100%" }}
                  >
                    {selectedCategory?.map((category) => (
                      <Option key={category.id} value={category.id}>
                        {category.name}
                      </Option>
                    ))}
                  </Select>
                </div>
                {errors.selectedCategoryIds && (
                  <p className="error">{errors.selectedCategoryIds}</p>
                )}
              </div>
              <div>
                <Buttons
                  onClick={handleAddCategory}
                  className="add-category-button"
                >
                  Add New Category
                </Buttons>
              </div>
            </div>
          </Card>
          <Card
            style={{ marginBottom: "10px" }}
            className="addcls_cont_Jdetails"
          >
            <div className="heading">
              <div className="heading_h1">Joining Details</div>
              <div className="heading_cont">
                Please provide the necessary details to complete the joining
                process. Select the appropriate mode of joining, assign a staff
                member, and specify the class type.
              </div>
            </div>
            <div className="join" style={{ marginBottom: "8px" }}>
              <label style={{ display: "block", marginBottom: "8px" }}>
                Join Type
              </label>
              <div
                style={{
                  width: "100%",
                  padding: "4px 8px",
                  background: "#f5f5f5",
                  borderRadius: 4,
                  border: "1px solid #d9d9d9",
                  color: "#888",
                  fontSize: 16,
                }}
              >
                Online
              </div>
            </div>

            {selectedValue === "offline" && (
              <div className="join">
                <label style={{ display: "block", marginBottom: "8px" }}>
                  Class Address
                </label>
                <FormInputs
                  type="text"
                  value={classAddress}
                  onChange={(e) => {
                    handleClassAddressChange(e);
                    setErrors((prevErrors) => ({
                      ...prevErrors,
                      classAddress: e.target.value
                        ? ""
                        : prevErrors.classAddress,
                    }));
                  }}
                  placeholder="Enter class address"
                />
                {errors.classAddress && (
                  <p className="error">{errors.classAddress}</p>
                )}
              </div>
            )}

            <div className="join">
              <label style={{ display: "block", marginBottom: "8px" }}>
                Class Type*
              </label>
              <Select
                placeholder="Select Class Type"
                name="mode"
                size="large"
                style={{ width: "100%" }}
                value={selectedGroup}
                onChange={(value) => {
                  handleClassTypeChange(value);
                  setErrors((prevErrors) => ({
                    ...prevErrors,
                    selectedGroup: value ? "" : prevErrors.selectedGroup,
                  }));
                }}
              >
                {options2?.map((option) => (
                  <Option key={option.id} value={option.id}>
                    {option.name}
                  </Option>
                ))}
              </Select>
              {errors.selectedGroup && (
                <p className="error">{errors.selectedGroup}</p>
              )}
            </div>
            <div className="join">
              <label style={{ display: "block", marginBottom: "8px" }}>
                Assign Instructor*
              </label>
              <Select
                placeholder="Assign Staff"
                name="instructor"
                size="large"
                style={{ width: "100%" }}
                value={selectedInstructorId}
                onChange={(value) => {
                  handleInstructorChange(value);
                  setErrors((prevErrors) => ({
                    ...prevErrors,
                    assignStaff: value ? "" : prevErrors.assignStaff,
                  }));
                }}
              >
                {selectedInstructor?.map((category) => (
                  <Option key={category.id} value={category.id}>
                    {category.name}
                  </Option>
                ))}
              </Select>
              {errors.assignStaff && (
                <p className="error">{errors.assignStaff}</p>
              )}
            </div>
            <div
              style={{
                marginTop: "20px",
                display: "flex",
                justifyContent: "flex-end",
              }}
            >
              <Buttons onClick={handleAddInstructor} disabled={isLoading}>
                Add New Instructor
              </Buttons>
            </div>
          </Card>

          <Card
            style={{ marginBottom: "10px" }}
            className="addcls_cont_booking"
          >
            <div className="addcls_cont_booking_attendence">
                <div className="one">
                  <FormInputs
                    disabled={selectedGroup === "one-on-one"}
                    type="number"
                    title="Total number of attendees*"
                    value={totalAttendence}
                    onChange={(e) => {
                      setTotalAttendence(e.target.value);
                      setErrors((prevErrors) => ({
                        ...prevErrors,
                        totalAttendence: e.target.value
                          ? ""
                          : prevErrors.totalAttendence,
                      }));
                    }}
                    placeholder="00"
                    style={{background: selectedGroup === "one-on-one" ? "#f5f5f5" : undefined}}
                  />
                  {errors.totalAttendence && (
                    <p className="error">{errors.totalAttendence}</p>
                  )}
                </div>
            </div>
          </Card>
          <Card style={{ marginBottom: "10px" }} className="addcls_cont_sec">
            <div className="addcls_cont_sec_main">
              <h3 className="addcls_cont_sec_main_title">Pricing( Weekly)</h3>
              <div
                className="addcls_cont_sec_main_title_inputs"
                style={{ display: "flex", flexDirection: 'column', gap: "15px", marginBottom: '25px' }}
              >
                <div style={{ display: "flex", gap: "20px" }}>
                  <div className="addcls_cont_sec_main_title_inputs_group">
                    <div className="price-field">
                      <FormInputs
                        type="number"
                        title={"INR price(Discounted)*"}
                        value={weeklyprice}
                        onChange={(e) => {
                          setWeeklyPrice(e.target.value);
                          setErrors((prevErrors) => ({
                            ...prevErrors,
                            price: e.target.value ? "" : prevErrors.price,
                            weeklyPriceCompare: "",
                          }));
                        }}
                        placeholder="00.00"
                      />
                      {errors.price && <p className="error">{errors.price}</p>}
                      {errors.weeklyPriceCompare && (
                        <p className="error">{errors.weeklyPriceCompare}</p>
                      )}
                    </div>
                  </div>
                  <div className="addcls_cont_sec_main_title_inputs_group">
                    <div className="price-field">
                      <FormInputs
                        type="number"
                        value={weeklycomparePrice}
                        title={"Compare at INR price(MRP)*"}
                        onChange={(e) => {
                          setWeeklyComparePrice(e.target.value);
                          setErrors((prevErrors) => ({
                            ...prevErrors,
                            comparePrice: e.target.value
                              ? ""
                              : prevErrors.comparePrice,
                            weeklyPriceCompare: "",
                          }));
                        }}
                        placeholder="00.00"
                      />
                      {errors.comparePrice && (
                        <p className="error">{errors.comparePrice}</p>
                      )}
                    </div>
                  </div>
                  <div className="addcls_cont_sec_main_option">
                    <label className="addcls_cont_sec_main_option_cont">
                      <input
                        type="checkbox"
                        checked={chargeTaxWeeklyInr}
                        onChange={(e) => setChargeTaxWeeklyInr(e.target.checked)}
                      />
                      <span className="checkmark"></span>
                      Charge tax on INR price
                    </label>
                  </div>
                </div>

                <div style={{ display: "flex", gap: "20px" }}>
                  <div className="addcls_cont_sec_main_title_inputs_group">
                    <div className="price-field">
                      <FormInputs
                        type="number"
                        value={weeklyusdPrice}
                        title={"USD Price(Discounted)*"}
                        onChange={(e) => {
                          setWeeklyUsdPrice(e.target.value);
                          setErrors((prevErrors) => ({
                            ...prevErrors,
                            usdPrice: e.target.value ? "" : prevErrors.usdPrice,
                            weeklyUsdPriceCompare: "",
                          }));
                        }}
                        placeholder="$ 00.00"
                      />
                      {errors.usdPrice && (
                        <p className="error">{errors.usdPrice}</p>
                      )}
                      {errors.weeklyUsdPriceCompare && (
                        <p className="error">{errors.weeklyUsdPriceCompare}</p>
                      )}
                    </div>
                  </div>
                  <div className="addcls_cont_sec_main_title_inputs_group">
                    <div className="price-field">
                      <FormInputs
                        type="number"
                        value={weeklycompareUsdPrice}
                        title={"Compare-at USD Price(MRP)*"}
                        onChange={(e) => {
                          setWeeklyCompareUsdPrice(e.target.value);
                          setErrors((prevErrors) => ({
                            ...prevErrors,
                            compareUsdPrice: e.target.value
                              ? ""
                              : prevErrors.compareUsdPrice,
                            weeklyUsdPriceCompare: "",
                          }));
                        }}
                        placeholder="$ 00.00"
                      />
                      {errors.compareUsdPrice && (
                        <p className="error">{errors.compareUsdPrice}</p>
                      )}
                    </div>
                  </div>
                  <div className="addcls_cont_sec_main_option">
                    <label className="addcls_cont_sec_main_option_cont">
                      <input
                        type="checkbox"
                        checked={chargeTaxWeeklyUsd}
                        onChange={(e) => setChargeTaxWeeklyUsd(e.target.checked)}
                      />
                      <span className="checkmark"></span>
                      Charge tax on USD price
                    </label>
                  </div>
                </div>
              </div>
            </div>

            <div className="addcls_cont_sec_main">
              <h3 className="addcls_cont_sec_main_title">Pricing (Monthly)</h3>
              <div
                className="addcls_cont_sec_main_title_inputs"
                style={{ display: "flex", flexDirection: 'column', gap: "15px" }}
              >
                <div style={{ display: "flex", gap: "20px" }}>
                  <div className="addcls_cont_sec_main_title_inputs_group">
                    <div className="price-field">
                      <FormInputs
                        type="number"
                        title={"INR price(Discounted)*"}
                        value={price}
                        onChange={(e) => {
                          setPrice(e.target.value);
                          setErrors((prevErrors) => ({
                            ...prevErrors,
                            price: e.target.value ? "" : prevErrors.price,
                            monthlyPriceCompare: "",
                          }));
                        }}
                        placeholder="00.00"
                      />
                      {errors.price && <p className="error">{errors.price}</p>}
                      {errors.monthlyPriceCompare && (
                        <p className="error">{errors.monthlyPriceCompare}</p>
                      )}
                    </div>
                  </div>
                  <div className="addcls_cont_sec_main_title_inputs_group">
                    <div className="price-field">
                      <FormInputs
                        type="number"
                        value={comparePrice}
                        title={"Compare at INR price(MRP)*"}
                        onChange={(e) => {
                          setComparePrice(e.target.value);
                          setErrors((prevErrors) => ({
                            ...prevErrors,
                            comparePrice: e.target.value
                              ? ""
                              : prevErrors.comparePrice,
                            monthlyPriceCompare: "",
                          }));
                        }}
                        placeholder="00.00"
                      />
                      {errors.comparePrice && (
                        <p className="error">{errors.comparePrice}</p>
                      )}
                    </div>
                  </div>
                  <div className="addcls_cont_sec_main_option">
                    <label className="addcls_cont_sec_main_option_cont">
                      <input
                        type="checkbox"
                        checked={chargeTaxMonthlyInr}
                        onChange={(e) => setChargeTaxMonthlyInr(e.target.checked)}
                      />
                      <span className="checkmark"></span>
                      Charge tax on INR price
                    </label>
                  </div>
                </div>
                <div style={{ display: "flex", gap: "20px" }}>
                  <div className="addcls_cont_sec_main_title_inputs_group">
                    <div className="price-field">
                      <FormInputs
                        type="number"
                        value={usdPrice}
                        title={"USD Price(Discounted)*"}
                        onChange={(e) => {
                          setUsdPrice(e.target.value);
                          setErrors((prevErrors) => ({
                            ...prevErrors,
                            usdPrice: e.target.value ? "" : prevErrors.usdPrice,
                            monthlyUsdPriceCompare: "",
                          }));
                        }}
                        placeholder="$ 00.00"
                      />
                      {errors.usdPrice && (
                        <p className="error">{errors.usdPrice}</p>
                      )}
                      {errors.monthlyUsdPriceCompare && (
                        <p className="error">{errors.monthlyUsdPriceCompare}</p>
                      )}
                    </div>
                  </div>
                  <div className="addcls_cont_sec_main_title_inputs_group">
                    <div className="price-field">
                      <FormInputs
                        type="number"
                        value={compareUsdPrice}
                        title={" Compare-at USD Price(MRP)*"}
                        onChange={(e) => {
                          setCompareUsdPrice(e.target.value);
                          setErrors((prevErrors) => ({
                            ...prevErrors,
                            compareUsdPrice: e.target.value
                              ? ""
                              : prevErrors.compareUsdPrice,
                            monthlyUsdPriceCompare: "",
                          }));
                        }}
                        placeholder="$ 00.00"
                      />
                      {errors.compareUsdPrice && (
                        <p className="error">{errors.compareUsdPrice}</p>
                      )}
                    </div>
                  </div>
                  <div className="addcls_cont_sec_main_option">
                    <label className="addcls_cont_sec_main_option_cont">
                      <input
                        type="checkbox"
                        checked={chargeTaxMonthlyUsd}
                        onChange={(e) => setChargeTaxMonthlyUsd(e.target.checked)}
                      />
                      <span className="checkmark"></span>
                      Charge tax on USD price
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </Card>

          <Card
            style={{ marginBottom: "10px" }}
            className="addcls_cont_timeslots"
          >
            <div className="heading">
              <div className="heading_main">Time Slot Settings</div>
              <div className="heading_content">
                Configure the duration of each session and allocate buffer time
                to ensure a smooth schedule.
              </div>
            </div>
            <div style={{ padding: 20 }}>
              <Row gutter={[24, 16]} align="top">
                <Col span={12}>
                  <Title level={5}>Duration</Title>
                  <div style={{ display: "flex", gap: "8px" }}>
                    {renderSelect(
                      duration.hours,
                      (value) => handleDurationChange("hours", value),
                      DurationHoursOptions
                    )}
                    {renderSelect(
                      duration.minutes,
                      (value) => handleDurationChange("minutes", value),
                      minutesOptions
                    )}
                  </div>
                </Col>

                <Col span={12}>
                  <Title level={5}>Buffer time</Title>
                  <div style={{ display: "flex", gap: "8px" }}>
                    {renderSelect(
                      buffer.hours,
                      (value) => handleBufferChange("hours", value),
                      hoursOptions
                    )}
                    {renderSelect(
                      buffer.minutes,
                      (value) => handleBufferChange("minutes", value),
                      minutesOptions
                    )}
                  </div>
                </Col>
              </Row>

              <Row gutter={[24, 16]} style={{ marginTop: 16 }} align="top">
                <Col span={12}>
                  <Title level={5}>Working days and time</Title>
                  <Button onClick={handleSlotsVisible} type="default" block>
                    Set Working days and time
                  </Button>
                </Col>

                <Col span={12}>
                  {assignedSlots && Object.keys(assignedSlots).length > 0 && (
                    <div style={{ display: "flex", flexWrap: "wrap", alignItems: "flex-start", gap: 12 }}>
                      {Object.entries(assignedSlots)
                        .filter(([, slots]) => slots?.length > 0)
                        .map(([day, slots], index, arr) => (
                          <React.Fragment key={day}>
                            <div style={{ display: "flex", flexDirection: "column" }}>
                              <span style={{
                                fontSize: 13,
                                fontWeight: 600,
                                color: "#d97706",
                                textDecoration: "underline",
                              }}>
                                {day}
                              </span>
                              {slots.map((slot, i) => (
                                <span key={i} style={{ fontSize: 12, color: "#6b7280" }}>
                                  {slot.startTime} to {slot.endTime} IST
                                </span>
                              ))}
                            </div>
                            {index < arr.length - 1 && (
                              <span style={{ color: "#d1d5db", fontWeight: 300, alignSelf: "center" }}>|</span>
                            )}
                          </React.Fragment>
                        ))}
                    </div>
                  )}
                </Col>
              </Row>
            </div>
          </Card>
          <Card style={{ marginBottom: "10px", borderRadius: "8px" }}>
            <Title level={5} strong>
              Others
            </Title>
            <Paragraph style={{ marginBottom: "12px" }}>
              Enable in-class review sessions to assess progress and provide
              feedback.
            </Paragraph>
            <Checkbox checked={isChecked} onChange={handleReviewChange}>
              Add Review In Class
            </Checkbox>
          </Card>
          <div style={{ display: "flex", justifyContent: "flex-end" }}>
            {classEditedData ? (
              <Buttons variant="primary" onClick={handleUpdateButtonClick}>
                Update
              </Buttons>
            ) : (
              <Buttons
                variant="primary"
                onClick={handleSaveButtonClick}
                disabled={isLoading}
              >
                {isLoading ? "Saving..." : "Save"}
              </Buttons>
            )}
          </div>
        </div>
      </div>

      <Modal
        title={
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <span>Weekly Schedule</span>
          </div>
        }
        open={isModalVisible}
        onCancel={() => setIsModalVisible(false)}
        onOk={handleSave}
        okText="Submit"
        width={1100}
      >
        {selectedOption === "hourly" && (
          <div style={{ marginBottom: "10px" }}>
            <label>Select Date Range:</label>
            <RangePicker
              value={startDate && endDate ? [startDate, endDate] : null}
              onChange={handleDateChange}
              disabledDate={(current) =>
                current && current < new Date().setHours(0, 0, 0, 0)
              }
            />
            {dateError && (
              <p style={{ color: "red", marginTop: "5px" }}>{dateError}</p>
            )}
          </div>
        )}
        <Tabs defaultActiveKey="1">
          {/* Tab 1: Assigned Slots */}
          {classEditedData?.length > 0 && (
            <TabPane tab="Assigned Slots" key="1">
              <p>Assigned slots of the class:</p>
              <div className="instform_contentModal_data">
                {assignedSlots && Object.keys(assignedSlots).length > 0 ? (
                  Object.entries(assignedSlots).map(([day, slots]) => (
                    <div key={day} className="schedule-day">
                      <h4 className="schedule-day-title">{day}</h4>
                      {slots?.map((slot, index) => (
                        <div
                          key={index}
                          className="schedule-slot "
                          style={{ marginTop: "10px" }}
                        >
                          <TimePicker
                            value={
                              slot.startTime
                                ? dayjs(slot.startTime, "HH:mm")
                                : null
                            }
                            placeholder="Start Time"
                            format="HH:mm"
                            disabled
                            allowClear={false}
                          />
                          <TimePicker
                            value={
                              slot.endTime ? dayjs(slot.endTime, "HH:mm") : null
                            }
                            placeholder="End Time"
                            format="HH:mm"
                            disabled
                            allowClear={false}
                          />
                          <Button
                            type={unassignSlotIds.includes(slot.id) ? "default" : "primary"}
                            onClick={() => handleToggleUnassign(slot.id)}
                          >
                            {unassignSlotIds.includes(slot.id)
                              ? "Cancel Unassign"
                              : "Unassign"}
                          </Button>
                          <Button
                            type="primary"
                            icon={<DeleteOutlined />}
                            onClick={() => handleRemoveSlot(day, slot.id)}
                            style={{
                              backgroundColor: "#ff4d4f",
                              borderRadius: "10%",
                              width: "30px",
                              height: "30px",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              border: "none",
                              color: "white",
                            }}
                          />
                        </div>
                      ))}
                    </div>
                  ))
                ) : (
                  <p>No assigned slots available.</p>
                )}
              </div>
            </TabPane>
          )}
          {/* Tab 2: Available Slots of Selected Instructor */}
          <TabPane tab="Available Slots (Instructor)" key="2">
            <p>Available slots of the selected instructor:</p>
            {renderSlotModeSwitcher()}
            <div className="instform_contentModal_data">
              {Object.keys(schedule).map((day) => (
                <div key={day} className="schedule-day">
                  <h4 className="schedule-day-title">{day}</h4>
                  <div style={{ display: "flex", gap: "24px", flexWrap: "wrap" }}>
                    {["online", "offline"].map((slotTypeKey) => {
                      const bucket = schedule[day][activeSlotMode][slotTypeKey];
                      return (
                        <div key={slotTypeKey} style={{ flex: 1, minWidth: "260px" }}>
                          <span
                            style={{
                              fontSize: "12px",
                              fontWeight: 600,
                              color: slotTypeKey === "online" ? "#3fd97f" : "#ff9c55",
                            }}
                          >
                            {slotTypeKey === "online" ? "Online" : "Offline"}
                          </span>
                          {bucket.slots.length > 0 ? (
                            bucket.slots.map((slot, index) => (
                              <div
                                key={slot.id ? String(slot.id) : index}
                                className="schedule-slot"
                                style={{ marginTop: "10px" }}
                              >
                                <TimePicker
                                  value={slot.start ? dayjs(slot.start, "HH:mm") : null}
                                  placeholder="Start Time"
                                  format="HH:mm"
                                  disabled
                                  allowClear={false}
                                />
                                <TimePicker
                                  value={slot.end ? dayjs(slot.end, "HH:mm") : null}
                                  placeholder="End Time"
                                  format="HH:mm"
                                  disabled
                                  allowClear={false}
                                />
                                <Button
                                  type={isSlotSelected(slot.id) ? "default" : "primary"}
                                  onClick={() => handleToggleSlot(day, slot)}
                                >
                                  {isSlotSelected(slot.id) ? "Unassign" : "Assign"}
                                </Button>
                              </div>
                            ))
                          ) : (
                            <p style={{ fontSize: "12px", color: "#999", marginTop: "8px" }}>
                              No slots
                            </p>
                          )}
                        </div>
                      );
                    })}
                  </div>
                </div>
              ))}
            </div>
          </TabPane>
          {/* Tab 3: Add New Slots */}
          <TabPane tab="Add New Slots" key="3">
            <p>Add new slots to the class:</p>
            {renderSlotModeSwitcher()}
            <div className="instform_contentModal_data">
              {Object.keys(schedule).map((day) => (
                <div key={day} className="schedule-day">
                  <h4 className="schedule-day-title">{day}</h4>
                  <div style={{ display: "flex", gap: "24px", flexWrap: "wrap" }}>
                    {["online", "offline"].map((slotTypeKey) => {
                      const bucket = schedule[day][activeSlotMode][slotTypeKey];
                      return (
                        <div key={slotTypeKey} style={{ flex: 1, minWidth: "280px" }}>
                          <div className="schedule-header">
                            <Switch
                              checked={bucket.isActive}
                              onChange={() => handleToggle(day, activeSlotMode, slotTypeKey)}
                            />
                            <span
                              style={{
                                marginLeft: "8px",
                                fontSize: "12px",
                                fontWeight: 600,
                                color: slotTypeKey === "online" ? "#3fd97f" : "#ff9c55",
                              }}
                            >
                              {slotTypeKey === "online" ? "Online" : "Offline"}
                            </span>
                          </div>
                          {bucket.isActive ? (
                            <>
                              {/* Manual slot input row */}
                              <div
                                className="schedule-slot"
                                style={{ marginTop: "10px", display: "flex", gap: 8, alignItems: "center" }}
                              >
                                <TimePicker
                                  value={newSlotInputs[day].start}
                                  placeholder="Start Time"
                                  format="HH:mm"
                                  onChange={(time) =>
                                    setNewSlotInputs((prev) => ({
                                      ...prev,
                                      [day]: { ...prev[day], start: time },
                                    }))
                                  }
                                  allowClear
                                />
                                <TimePicker
                                  value={newSlotInputs[day].end}
                                  placeholder="End Time"
                                  format="HH:mm"
                                  onChange={(time) =>
                                    setNewSlotInputs((prev) => ({
                                      ...prev,
                                      [day]: { ...prev[day], end: time },
                                    }))
                                  }
                                  allowClear
                                />
                                <Button
                                  type="dashed"
                                  icon={<PlusOutlined />}
                                  onClick={() => handleAddManualSlot(day, activeSlotMode, slotTypeKey)}
                                >
                                  Add Slot
                                </Button>
                              </div>

                              <div
                                className="schedule-slots"
                                style={{
                                  marginTop: "10px",
                                  display: "grid",
                                  gridTemplateColumns: "repeat(2, minmax(220px, 1fr))",
                                  gridAutoRows: "auto",
                                  gap: "8px 16px",
                                }}
                              >
                                {sortSlotsByStart(bucket.slots).map((slot, index) => (
                                  <div
                                    key={slot.id ? String(slot.id) : `${slot.start || 's'}-${slot.end || 'e'}-${index}`}
                                    className="schedule-slot"
                                  >
                                    <TimePicker
                                      value={slot.start ? dayjs(slot.start, "HH:mm") : null}
                                      placeholder="Start Time"
                                      format="HH:mm"
                                      onChange={(time) =>
                                        handleTimeChange(day, index, time, "start", activeSlotMode, slotTypeKey)
                                      }
                                      allowClear={false}
                                    />
                                    <TimePicker
                                      value={slot.end ? dayjs(slot.end, "HH:mm") : null}
                                      placeholder="End Time"
                                      format="HH:mm"
                                      onChange={(time) =>
                                        handleTimeChange(day, index, time, "end", activeSlotMode, slotTypeKey)
                                      }
                                      allowClear={false}
                                    />
                                    <Button
                                      type="danger"
                                      icon={<DeleteOutlined />}
                                      onClick={() => removeTimeSlot(day, index, activeSlotMode, slotTypeKey)}
                                      style={{
                                        backgroundColor: "#ff4d4f",
                                        borderRadius: "10%",
                                        width: "30px",
                                        height: "30px",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        border: "none",
                                        color: "white",
                                      }}
                                    />
                                  </div>
                                ))}
                              </div>
                            </>
                          ) : (
                            <p>Unavailable</p>
                          )}
                        </div>
                      );
                    })}
                  </div>
                </div>
              ))}
            </div>
          </TabPane>
        </Tabs>
      </Modal>
      <Modal
        open={addCategoryForm}
        onCancel={() => setAddCategoryForm(false)}
        onOk={handleSaves}
        footer={false}
        okText="Submit"
        width={600}
      >
        <CategoryManagementForm
          addCategoryForm={addCategoryForm}
          setAddCategoryForm={setAddCategoryForm}
        />
      </Modal>
      <Modal
        open={addInstructorForm}
        onCancel={() => setShowAddInstructorForm(false)}
        onOk={handleSaves}
        okText="Submit"
        footer={false}
        width={600}
      >
        <InstructorForm
          addInstructorForm={addInstructorForm}
          setShowAddInstructorForm={setShowAddInstructorForm}
          isClassManagementSection={true}
        />
      </Modal>
    </>
  );
};

export default DaylightClassForm;
